/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIDatasetWithPreviewUpdate
 */
export interface AIDatasetWithPreviewUpdate {
    /**
     * 
     * @type {string}
     * @memberof AIDatasetWithPreviewUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AIDatasetWithPreviewUpdate
     */
    type?: AIDatasetWithPreviewUpdateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AIDatasetWithPreviewUpdate
     */
    connection: number;
}

/**
* @export
* @enum {string}
*/
export enum AIDatasetWithPreviewUpdateTypeEnum {
    Normal = 'normal',
    FaceLibrary = 'face-library',
    Stt = 'stt'
}

export function AIDatasetWithPreviewUpdateFromJSON(json: any): AIDatasetWithPreviewUpdate {
    return AIDatasetWithPreviewUpdateFromJSONTyped(json, false);
}

export function AIDatasetWithPreviewUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIDatasetWithPreviewUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'connection': json['connection'],
    };
}

export function AIDatasetWithPreviewUpdateToJSON(value?: AIDatasetWithPreviewUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'connection': value.connection,
    };
}


